<template>
  <div id="app">
    <app-header></app-header>
    <router-view />
    <app-footer></app-footer>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

import AppHeader from "./view/header.vue";
import AppFooter from "./view/footer.vue";
import SeoUpdate from "./main.js";
import axios from "axios";

export default {
  name: "App",
  components: {
    AppHeader,
    AppFooter,
  },
  data() {
    return {};
  },
  methods: {
    keywordSet() {
      axios
        .get("http://yunthee.com/website-dev/website/SEO/get")
        .then((res) => {
          window.SeoUpdate(
            res.data.data.title,
            res.data.data.keywords,
            res.data.data.description
          );
        });
      // window.SeoUpdate('思高科技|RPA机器人|财务机器人|系统平台开发|软件定制',
      //   '武汉RPA,湖北RPA,武汉RPA机器人,湖北RPA机器人,RPA机器人流程自动化,RPA机器人,思高科技,湖北思高科技,湖北思高,武汉思高,RPANEWS,' +
      //   'rpa案例,rpa应用,财务机器人,RPA咨询,RPA认证','湖北思高科技是一家以RPA+AI为主要技术手段，致力于推进政企办公智能化转型；同时提供网站、微信公众号、小程序、系统平台建设及运维服务的高科技企业。')
    },
    goBack() {
      let tag = document.location.href.slice(28, 30);
      let index = 0;
      if (tag === "cm") {
        index = 1;
      }
      if (tag === "cu") {
        index = 2;
      }
      if (tag === "go") {
        index = 3;
      }
      if (tag === "ne") {
        index = 4;
      }
      if (tag === "jo") {
        index = 5;
      }
      sessionStorage.index = index;
      this.$EventBus.$emit("selectTab", index);
      this.$EventBus.$emit("setTitleStyle");
      this.$EventBus.$emit("setClass");
    },
  },
  mounted() {
    this.keywordSet();
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.RUL);
      window.addEventListener("popstate", this.goBack, false);
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.goBack, false);
  },
};
</script>

<style>
#title {
  font-size: 28px;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  height: 100vh;
  color: #2c3e50;
  /* margin-top: 60px; */
}
body {
  margin: 0 !important;
  /* background: #F0F2F5; */
  background: white;
}
.public-scroll::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
  margin-bottom: 40px;
}

.public-scroll::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #535353;
}
.public-scroll::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}

.showBtn .el-carousel__arrow {
  display: none;
}

@media screen and (max-width: 1200px) {
  .container {
    padding-top: 70px;
  }
}
</style>
